"use strict";
exports.__esModule = true;
exports.SvgColoredChartWidget = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgColoredChartWidget = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 48 48" }, props),
    react_1["default"].createElement("path", { d: "M0 0h48v48H0V0z", fill: "#E6EEDE", fillRule: "evenodd" }),
    react_1["default"].createElement("rect", { width: 7.02, height: 18, y: 17, fill: "#719F40", rx: 0.5, x: 10, fillRule: "evenodd" }),
    react_1["default"].createElement("rect", { width: 7, height: 11.34, x: 31, y: 23.66, fill: "#9DC077", rx: 0.5, fillRule: "evenodd" }),
    react_1["default"].createElement("rect", { width: 7, height: 23, x: 20.5, fill: "#51801F", rx: 0.5, y: 12, fillRule: "evenodd" }),
    react_1["default"].createElement("rect", { width: 36, height: 2, x: 6, y: 34, fill: "#51801F", rx: 1, fillRule: "evenodd" }))); };
//# sourceMappingURL=ColoredChartWidget.js.map